import InterestsSettings from './InterestsSettings.vue';

export default InterestsSettings;



// WEBPACK FOOTER //
// ./src/pages/profile/views/interests/index.ts